import { z } from "zod";
import { discoveryItemSchema, mediaTypeSchema } from "./discovery.js";

/**
 * Watchlist — per-user saves keyed by TMDB id, hydrated server-side from
 * Rago Discovery. `item` is null when TMDB hydration failed (transient);
 * the entry itself never disappears from the account.
 */
export const watchlistEntrySchema = z.object({
  mediaType: mediaTypeSchema,
  tmdbId: z.string(), // TMDB id as string, matching DiscoveryItem.id
  addedAt: z.string(),
  item: discoveryItemSchema.nullable(),
});
export type WatchlistEntry = z.infer<typeof watchlistEntrySchema>;

export const watchlistResponseSchema = z.object({
  items: z.array(watchlistEntrySchema),
});
export type WatchlistResponse = z.infer<typeof watchlistResponseSchema>;
